<section class="sports-menu sb-panel" [class.sports-menu--collapsed]="!expanded()" [attr.aria-busy]="loading()">
  <header class="sports-menu__header">
    <h2 class="sports-menu__title" [class.sports-menu__title--hidden]="!expanded()">{{ 'sportsMenu.title' | translate }}</h2>
    <button
      type="button"
      class="sports-menu__toggle sb-icon-button"
      [attr.aria-label]="((expanded() ? 'sportsMenu.collapse' : 'sportsMenu.expand') | translate)"
      (click)="toggleExpanded.emit()"
    >
      <span class="material-symbols-outlined sports-menu__toggle-icon" aria-hidden="true">
        {{ expanded() ? 'chevron_left' : 'chevron_right' }}
      </span>
    </button>
  </header>

  @if (loading()) {
    <span class="sports-menu__sr-only">{{ 'home.loading' | translate }}</span>
  }

  <ul class="sports-menu__list sb-scrollbar" role="list">
    @if (loading()) {
      @for (index of skeletonIndexes; track index) {
        <li class="sports-menu__item sports-menu__item--skeleton" aria-hidden="true">
          <div class="sports-menu__button sports-menu__button--skeleton" [class.sports-menu__button--collapsed]="!expanded()">
            <span class="sports-menu__indicator" aria-hidden="true"></span>
            <span class="sports-menu__icon-shell">
              <span class="sports-menu__skeleton sports-menu__skeleton--icon"></span>
            </span>
            <span class="sports-menu__details" [class.sports-menu__details--hidden]="!expanded()">
              <span class="sports-menu__skeleton sports-menu__skeleton--label"></span>
              <span class="sports-menu__skeleton sports-menu__skeleton--stats"></span>
            </span>
          </div>
        </li>
      }
    } @else {
      @for (sport of sports(); track trackSport($index, sport)) {
        <li class="sports-menu__item">
          <button
            type="button"
            class="sports-menu__button"
            [class.sports-menu__button--selected]="sport.selected"
            [class.sports-menu__button--collapsed]="!expanded()"
            [attr.aria-pressed]="sport.selected"
            [attr.aria-label]="sport.label"
            [attr.title]="!expanded() ? sport.label : null"
            (click)="sportToggle.emit(sport.id)"
          >
            <span class="sports-menu__indicator" aria-hidden="true"></span>
            <span class="sports-menu__icon-shell">
              <app-sport-icon [name]="sport.iconName"></app-sport-icon>
            </span>
            <span class="sports-menu__details" [class.sports-menu__details--hidden]="!expanded()">
              <span class="sports-menu__label">{{ sport.label }}</span>
              <span class="sports-menu__stats" aria-hidden="true">
                @if (sport.liveCount > 0) {
                  <span class="sports-menu__live-count">{{ sport.liveCount }}</span>
                  <span class="sports-menu__slash">/</span>
                }
                <span>{{ sport.totalCount }}</span>
              </span>
            </span>
          </button>
        </li>
      }
    }
  </ul>
</section>
